<template>
    <div class="page not-found">
        <SectionRotatorTest /> 
    </div>
</template>

<script>
import SectionRotatorTest from '@/components/rotator-section/SectionRotatorTest';

export default {
    components: {
        SectionRotatorTest
    },
    metaInfo: {
        title: 'Страница не найдена',
        titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
    },
}
</script>

<style>
.page {
    padding: 0;
}

canvas {
    margin-top: 40px;
}
</style>